module.exports = __webpack_public_path__ + "static/offers-91a56b200da341777a72843a91bc6b8f.png";